module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "relative-top-fourthly"
  }, [_c('div', {
    staticClass: "weui-cells"
  }, [_c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [(_vm.isLogin) ? _c('img', {
    staticClass: "img-circle profile-img",
    attrs: {
      "src": _vm.user.profileURL
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('img', {
    staticClass: "img-circle profile-img",
    attrs: {
      "src": require("../assets/default_user_icon.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.user.chineseLastname) + _vm._s(_vm.user.chinesename) + " ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "weui-cell__ft"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.firstname) + " " + _vm._s(_vm.user.lastname))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "weui-cell__ft"
  }, [_c('a', {
    staticClass: "weui-btn weui-btn_mini weui-btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
    staticClass: "weui-btn weui-btn_mini weui-btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.signup
    }
  }, [_vm._v("注册")])])])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells"
  }, [_c('div', {
    staticClass: "weui-cell"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column center left-column"
  }, [(_vm.isLogin) ? _c('p', [_vm._v(_vm._s(_vm.user.money.balance))]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('p', [_vm._v("--")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("余额")])]), _vm._v(" "), _c('div', {
    staticClass: "column center right-column"
  }, [(_vm.isLogin) ? _c('p', [_vm._v(_vm._s(_vm.user.money.blockedBalance))]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('p', [_vm._v("--")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("冻结金额")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells"
  }, [_c('a', {
    staticClass: "weui-cell weui-cell_access",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.profile
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('a', {
    staticClass: "weui-cell weui-cell_access",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.card
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('a', {
    staticClass: "weui-cell weui-cell_access",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.hotline
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "weui-cells logout"
  }, [_c('div', {
    staticClass: "weui-cell weui-cell_access",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(6)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-footer footer"
  }, [_c('p', {
    staticClass: "weui-footer__links"
  }, [_c('a', {
    staticClass: "weui-footer__link",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.terms
    }
  }, [_vm._v("用户协议")]), _vm._v(" "), _c('a', {
    staticClass: "weui-footer__link",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.terms
    }
  }, [_vm._v("隐私政策")])]), _vm._v(" "), _c('p', {
    staticClass: "weui-footer__text"
  }, [_vm._v("Copyright © 2016-2017 小幕（北京）科技有限公司")])])])]), _vm._v(" "), _c('tab-bar'), _vm._v(" "), _c('download-app'), _vm._v(" "), _c('we-reactive-dialog', {
    attrs: {
      "is-show-dialog": _vm.isShowDownloadDialog
    },
    on: {
      "secondOnClick": _vm.cancelDownload,
      "mainOnClick": _vm.doDownload
    }
  }, [_c('div', {
    slot: "title"
  }, [_vm._v("下载APP")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v("目前仅支持APP内注册")]), _vm._v(" "), _c('div', {
    slot: "main-operation"
  }, [_vm._v("去下载")]), _vm._v(" "), _c('div', {
    slot: "secondly-operation"
  }, [_vm._v("取消")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../assets/personal_info.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("个人信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../assets/my_qr.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("我的二维码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('img', {
    staticClass: "cell-icon",
    attrs: {
      "src": require("../assets/help_icon.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v("实时客服帮助")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__bd center"
  }, [_c('p', [_vm._v("退出登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89535ed0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Me.vue
// module id = 197
// module chunks = 2